import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'

export default function ProgramSelector({
  utilityPrograms,
  selected,
  onChange,
  disabled,
}) {
  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id="program-select-label">Select a Program</InputLabel>
      <Select
        labelId="program-select-label"
        value={selected}
        label="Select a Program"
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value={-1}>Select A Program</MenuItem>
        {utilityPrograms.map((program) => (
          <MenuItem key={program.id} value={program.id}>
            {program.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
